// Nature soundscapes synthesised with the Web Audio API (no audio files).
const noiseBuffer = (ctx, kind) => {
  const len = ctx.sampleRate * 4;
  const buf = ctx.createBuffer(2, len, ctx.sampleRate);
  for (let ch = 0; ch < 2; ch++) {
    const d = buf.getChannelData(ch);
    let last = 0, b0 = 0, b1 = 0, b2 = 0;
    for (let i = 0; i < len; i++) {
      const w = Math.random() * 2 - 1;
      if (kind === "brown") { last = (last + 0.02 * w) / 1.02; d[i] = last * 3.5; }
      else { b0 = 0.997 * b0 + w * 0.029591; b1 = 0.985 * b1 + w * 0.032534; b2 = 0.95 * b2 + w * 0.048056; d[i] = (b0 + b1 + b2 + w * 0.1848) * 0.35; }
    }
  }
  return buf;
};

const loop = (ctx, buf) => { const s = ctx.createBufferSource(); s.buffer = buf; s.loop = true; s.start(); return s; };
const filter = (ctx, type, freq, q = 0.7) => { const f = ctx.createBiquadFilter(); f.type = type; f.frequency.value = freq; f.Q.value = q; return f; };
const lfo = (ctx, rate, depth, target) => {
  const o = ctx.createOscillator(); const g = ctx.createGain();
  o.frequency.value = rate; g.gain.value = depth; o.connect(g).connect(target); o.start(); return o;
};

const rain = (ctx, out) => {
  const hp = filter(ctx, "highpass", 800); const lp = filter(ctx, "lowpass", 7000);
  loop(ctx, noiseBuffer(ctx, "pink")).connect(hp).connect(lp).connect(out);
  const low = filter(ctx, "lowpass", 400); const lg = ctx.createGain(); lg.gain.value = 0.6;
  loop(ctx, noiseBuffer(ctx, "brown")).connect(low).connect(lg).connect(out);
  return () => {};
};

const ocean = (ctx, out) => {
  const lp = filter(ctx, "lowpass", 600); const g = ctx.createGain(); g.gain.value = 0.55;
  loop(ctx, noiseBuffer(ctx, "brown")).connect(lp).connect(g).connect(out);
  lfo(ctx, 0.08, 0.45, g.gain);
  lfo(ctx, 0.08, 350, lp.frequency);
  return () => {};
};

const chirp = (ctx, out) => {
  const t = ctx.currentTime; const o = ctx.createOscillator(); const g = ctx.createGain();
  const base = 2500 + Math.random() * 1800;
  o.type = "sine";
  o.frequency.setValueAtTime(base, t);
  o.frequency.exponentialRampToValueAtTime(base * (1.2 + Math.random() * 0.5), t + 0.08);
  o.frequency.exponentialRampToValueAtTime(base * 0.9, t + 0.16);
  g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(0.05, t + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.18);
  o.connect(g).connect(out); o.start(t); o.stop(t + 0.2);
};

const forest = (ctx, out) => {
  const bp = filter(ctx, "bandpass", 500, 0.4); const g = ctx.createGain(); g.gain.value = 0.35;
  loop(ctx, noiseBuffer(ctx, "pink")).connect(bp).connect(g).connect(out);
  lfo(ctx, 0.05, 0.2, g.gain);
  let timer;
  const sing = () => {
    const n = 1 + Math.floor(Math.random() * 3);
    for (let i = 0; i < n; i++) setTimeout(() => chirp(ctx, out), i * 220);
    timer = setTimeout(sing, 2500 + Math.random() * 5000);
  };
  timer = setTimeout(sing, 1500);
  return () => clearTimeout(timer);
};

const wind = (ctx, out) => {
  const bp = filter(ctx, "bandpass", 450, 0.8); const g = ctx.createGain(); g.gain.value = 0.7;
  loop(ctx, noiseBuffer(ctx, "pink")).connect(bp).connect(g).connect(out);
  lfo(ctx, 0.05, 220, bp.frequency);
  lfo(ctx, 0.07, 0.3, g.gain);
  return () => {};
};

const MAKERS = { rain, ocean, forest, wind };
export const STORY_SOUNDS = [
  { id: "off", name: "None", icon: "🔇" },
  { id: "rain", name: "Rain", icon: "🌧️" },
  { id: "ocean", name: "Waves", icon: "🌊" },
  { id: "wind", name: "Soft wind", icon: "🍃" },
];
export const SOUNDS = [
  { id: "off", name: "Off", icon: "🔇" },
  { id: "rain", name: "Rain", icon: "🌧️" },
  { id: "ocean", name: "Ocean", icon: "🌊" },
  { id: "forest", name: "Forest", icon: "🌲" },
];

export function startAmbient(kind, volume) {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx || !MAKERS[kind]) return null;
  const ctx = new Ctx();
  const master = ctx.createGain();
  master.gain.setValueAtTime(0, ctx.currentTime);
  master.gain.linearRampToValueAtTime(volume, ctx.currentTime + 1.5);
  master.connect(ctx.destination);
  const cleanup = MAKERS[kind](ctx, master);
  ctx.resume();
  return {
    setVolume: (v) => master.gain.setTargetAtTime(v, ctx.currentTime, 0.1),
    stop: () => { cleanup(); master.gain.setTargetAtTime(0, ctx.currentTime, 0.2); setTimeout(() => ctx.close(), 600); },
    fadeOut: (sec) => { cleanup(); master.gain.cancelScheduledValues(ctx.currentTime); master.gain.setValueAtTime(master.gain.value, ctx.currentTime); master.gain.linearRampToValueAtTime(0, ctx.currentTime + sec); setTimeout(() => ctx.close(), sec * 1000 + 200); },
  };
}
